import Vue from 'vue'
import AbstractComponent from '@/components/common/AbstractComponent'
import { LevelsHelper } from '@/store/levelsHelper'

@AbstractComponent
export default abstract class BubblesLevelsMixin extends Vue {
    abstract get levelsHelper(): LevelsHelper

    isLeafLevel (level:number) {
      return level === this.levelsHelper.maxLevel
    }

    doesAnAdjacentLevelNotShowBubbles (level: number) {
      const prevLevel = this.levelsHelper.levels.find(f => f.level === level - 1 && !f.showBubbles)
      const nextLevel = this.levelsHelper.levels.find(f => f.level === level + 1 && !f.showBubbles)
      // Level 1 may always be deselected. Level 2 should not be disabled if level 1 is deselected
      return !!(level !== 1 && (nextLevel || (level > 2 && prevLevel)))
    }

    showBubblesDisabled (level: number) {
      return this.isLeafLevel(level) || this.doesAnAdjacentLevelNotShowBubbles(level)
    }

    bubblesExplanation (level: number) {
      return this.isLeafLevel(level)
        ? 'Your last level must have Show as Bubbles selected.'
        : this.doesAnAdjacentLevelNotShowBubbles(level)
          ? 'Adjacent levels must not be deselected.'
          : ''
    }
}
